import { render } from "./ResultsList.vue?vue&type=template&id=b72988ce&scoped=true"
import script from "./ResultsList.vue?vue&type=script&lang=js"
export * from "./ResultsList.vue?vue&type=script&lang=js"

import "./ResultsList.vue?vue&type=style&index=0&id=b72988ce&lang=scss"
import "./ResultsList.vue?vue&type=style&index=1&id=b72988ce&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2524174443/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72988ce"]])

export default __exports__